export enum SearchLogic {
	Include = 'Include',
	Exclude = 'Exclude',
}
